import { graphql } from "../../gql";

/**
 * Fragment containing all fields for a complete song/TOC entry.
 * Reusable across queries and mutations.
 */
graphql(`
  fragment SongFields on SongUB {
    __typename
    author
    bucket
    createdAt
    id
    language
    lastUpdatedBy
    license
    chordsheet
    songnumbers {
      mnemonicNumber
      number
      songbook {
        id
        mnemonic
        name
        bucket
      }
    }
    tags
    title
    tonality
    updatedAt
    versionDescription
    sourceHashes
    imageHashes {
      hash
      key
      sourceHash
      manuallyModified
    }
  }
`);
